import React from "react";
import "./EarlyBirdBonuses.scss";

const EarlyBirdBonuses = () => {

  const bonuses = [
    {
      badge: "DISCOUNTED PRICE",
      iconColor: "#FF8C42",
      icon: "fa fa-gift",
      title: "Discounted Ticket Price",
      subtitle: "",
      originalPrice: "₹2,499",
      discountedPrice: "₹999",
      pricingTiers: [
        "1 Ticket: ₹999/- per ticket ",
        "2 Tickets: ₹939/- per ticket ",
        "3+ Tickets: ₹899/- per ticket ",
      ],
      features: [
        "Get instant access to tools & templates",
        "Exclusive savings & bonuses",
        "Limited spots available",
      ],
      gradient: "linear-gradient(135deg, #FF8C42 0%, #FF6B35 100%)",
    },
    {
      badge: "FREE BONUS",
      iconColor: "#4ECB71",
      icon: "fa fa-line-chart",
      title: "Free Financial Health Check",
      subtitle: "",
      features: [
        "Personalized business analysis",
        "Growth recommendations",
        "Risk assessment report",
      ],
      gradient: "linear-gradient(135deg, #4ECB71 0%, #2DB853 100%)",
    },
    {
      badge: "FREE BOOK",
      iconColor: "#4A90E2",
      icon: "fa fa-book",
      title: "Free Cash Flow Book",
      subtitle: "by CA Jagmohan Singh",
      features: [
        '"Financial Freedom with Financial Control"',
        "Practical scaling strategies",
        "Expert insights & case studies",
      ],
      gradient: "linear-gradient(135deg, #4A90E2 0%, #357ABD 100%)",
    },
    {
      badge: "VIP ACCESS",
      iconColor: "#9B59B6",
      icon: "fa fa-video-camera",
      title: "VIP 5AM Cash Flow Sessions",
      subtitle: "",
      features: [
        "Cash Flow Management Fundamentals",
        "Forecasting & Planning Strategies",
        "Live Q&A with experts",
      ],
      gradient: "linear-gradient(135deg, #9B59B6 0%, #7D3C98 100%)",
    },
  ];

  return (
    <section className="early-bird-bonuses-section-new">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="section-title-new text-center">
              <h2>Early Bird Bonuses</h2>
              <p>
                Unlock ₹10,000+ Worth of Premium Bonuses - Limited Time Offer
              </p>
            </div>
          </div>
        </div>

        <div className="bonuses-grid-new">
          {bonuses.map((bonus, index) => (
            <div key={index} className="bonus-container-new">
              <div className="badge-new">{bonus.badge}</div>

              <div className="icon-section-new">
                <div
                  className="icon-circle-new"
                  style={{ background: bonus.gradient }}
                >
                  <i className={bonus.icon}></i>
                </div>
              </div>

              <h3 className="title-new">{bonus.title}</h3>

              {bonus.subtitle && (
                <p className="subtitle-new">{bonus.subtitle}</p>
              )}

              {bonus.originalPrice && bonus.discountedPrice && (
                <div className="pricing-new">
                  <span className="original-price-new">
                    {bonus.originalPrice}
                  </span>
                  <span className="discounted-price-new">
                    {bonus.discountedPrice}
                  </span>
                </div>
              )}

              {bonus.pricingTiers ? (
                <ul className="features-new">
                  {bonus.pricingTiers.map((tier, idx) => (
                    <li key={idx} className="feature-item-new">
                      <i className="fa fa-check"></i>
                      <span>{tier}</span>
                    </li>
                  ))}
                </ul>
              ) : (
                <ul className="features-new">
                  {bonus.features.map((feature, idx) => (
                    <li key={idx} className="feature-item-new">
                      <i className="fa fa-check"></i>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default EarlyBirdBonuses;
